<template>
    <div class="modal" :class="{'modal__visible': visible}">
        <div class="modal-overlay" @click="closeIfAllowed"></div>
        <div class="modal-content" role="document">
            <div class="header" v-if="title">
                <h5 class="modal-title">{{ title }}</h5>
                <a href="javascript:;" title="Close this modal" @click="close" v-if="!hideClose" class="close">&times;</a>
            </div>
            <form @submit.prevent="$emit('submit')" ref="modalForm">
                <div class="main">
                    <a href="javascript:;" title="Close this modal" @click="close" v-if="!hideClose && !title" class="close">&times;</a>
                    <div><slot></slot></div>
                </div>
                <div class="footer">
                    <a href="javascript:;" @click="close()" class="close" v-if="closeLabel">{{ closeLabel }}</a>
                    <button type="submit" class="button" :class="submitClass" v-if="submit">{{ submit }}</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    emits: ['show', 'shown', 'hide', 'hidden'],
    props: {
        title: {
            type: String,
            required: false,
            default: null
        },
        hideClose: {
            type: Boolean,
            required: false,
            default: false
        },
        closeLabel: {
            type: String,
            required: false,
            default: null
        },
        submit: {
            type: String,
            required: false,
            default: null
        },
        submitClass: {
            type: String,
            required: false,
            default: null
        }
    },
    data () {
        return {
            visible: false,
            canClose: true,
            transcient: null
        }
    },
    created () {
        window.document.addEventListener('keydown', this.onKeydown)
    },
    destroyed () {
        window.document.removeEventListener('keydown', this.onKeydown)
    },
    methods: {
        onKeydown ($event) {
            if (!this.visible) {
                return
            }

            if ('key' in $event) {
                if ($event.key.toLowerCase().substr(0, 3) === 'esc') {
                    this.close()
                }
            } else if ($event.keyCode === 27) {
                this.close()
            }
        },
        close (reset) {
            this.$emit('close')
            this.visible = false
            if (reset) {
                this.transcient = null
            }
            setTimeout(() => {
                this.$emit('hidden')
            }, 500)
        },
        closeIfAllowed () {
            if (this.canClose) {
                this.close()
            }
        },
        show () {
            this.$emit('show')
            this.visible = true
            this.canClose = false
            setTimeout(() => {
                this.canClose = true
                this.$emit('shown')
            }, 500)
        },
        setTranscient (val) {
            this.transcient = val
        },
        getTranscient () {
            return this.transcient
        }
    }
}
</script>

<style lang="scss" scoped>
    @import '../../public/css/vars';

    .modal {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 999;
        transform: scale(0);

        &.modal__visible {
            transform: scale(1);
            .modal-overlay {
                opacity: 1;
            }

            .modal-content {
                transform: scale(1);
            }
        }

        .modal-overlay {
            position: fixed;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            display: block;
            background-color: rgba(0, 0, 0, 0.4);
            opacity: 0;
        }

        .modal-content {
            transition: .25s;
            transform: scale(0);
            background-color: #fff;
            display: block;
            width: 640px;
            z-index: 1;
            border-radius: 4px;
            box-shadow: 10px 10px 50px rgba(0, 0, 0, 0.5);

            a.close {
                border-bottom: none;
                color: #878998;
                transition: color 250ms ease-in-out;
                font-size: 1.2em;
                margin-right: 10px;

                &:hover {
                    color: darken(#878998, 20%);
                }
            }

            .header {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: baseline;
                border-bottom: solid 1px #ddd;
                padding: 10px 10px;
                margin-bottom: 20px;

                h5 {
                    margin: 0;
                    padding: 0;
                }
            }

            .main {
                max-height: calc(100vh - 200px);
                overflow-y: auto;
                padding: 0 20px;
                margin: 0;
                position: relative;

                .close {
                    position: absolute;
                    top: 5px;
                    right: 10px;
                    left: auto;
                    bottom: auto;
                }

                input, select, textarea {
                    border: solid 1px $form-text-color;
                    padding: 5px 10px;
                    border-radius: 4px;
                    transition: border $transition;

                    &:focus, &:focus::placeholder {
                        border-color: $button-light-border-color
                    }
                }
            }

            .footer {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: baseline;
                border-top: solid 1px #ddd;
                padding: 20px;
                margin: 0px 0 0 0;
                font-size: 0.8em;

                input, button, .btn {
                    margin-bottom: 0;
                    padding: 10px 30px;
                }

                a.close {
                    color: #878998;
                    border: solid #878998 1px;
                    border-radius: 20px;
                    padding: 5px 15px;

                    &:hover { color: darken(#878998, 20%) }
                }
            }
        }
    }
</style>
